import { Seo, breadcrumbSchema } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { PageHero, SectionHead, CtaBand, FaqList } from "@/components/Blocks";
import { PROCESS } from "@/data/home";

const FAQS = [
  ["How long does discovery take?", "It depends on the size of the project. A website or single workflow may need a few conversations, while an ERP programme may need several workshops across departments."],
  ["Do we need a detailed specification before contacting you?", "No. A short description of your business, current tools and main challenges is enough to start. We help shape the specification."],
  ["Can we start small?", "Yes. We often recommend a focused first phase that proves value before expanding the scope."],
  ["How do we stay informed during development?", "Through regular demos, shared progress updates and a clear point of contact, on a schedule agreed at the start of the project."],
];

export default function Process() {
  const crumbs = [["Home", "/"], ["Our Process", "/process"]];
  return (
    <>
      <Seo title="Our Process | From Industrial Challenge to Digital Solution" description="How Industrix Solution delivers industrial software and websites: discover, strategize, design, develop and test, then launch and improve with agreed support." path="/process" jsonLd={[breadcrumbSchema(crumbs)]} />
      <PageHero crumbs={crumbs} eyebrow="Our working process" lines={["From Business", "Challenge to", "Digital Solution"]} intro="A clear, collaborative process keeps projects focused on business outcomes, reduces risk and makes sure the people who will use the system shape it from the start." img="lathe" imgAlt="Precision lathe machining a metal component" />
      <section className="wrap py-24 lg:py-32" data-testid="process-detail">
        <ol className="border-t border-charcoal/15">
          {PROCESS.map(([t, d, more], i) => (
            <Reveal as="li" key={t} className="grid gap-6 border-b border-charcoal/15 py-12 md:grid-cols-[120px_1fr_1.3fr] md:gap-12">
              <span className="font-display text-6xl font-extrabold leading-none text-rust" style={{ fontStretch: "125%" }}>0{i + 1}</span>
              <div>
                <h2 className="font-display text-3xl font-bold">{t}</h2>
                <p className="mt-3 text-[16px] text-graphite">{d}</p>
              </div>
              <p className="text-[15px] leading-relaxed text-graphite md:pt-2">{more}</p>
            </Reveal>
          ))}
        </ol>
      </section>
      <section className="border-t border-stone bg-white py-24 lg:py-32" data-testid="process-faq">
        <div className="wrap grid gap-14 lg:grid-cols-[0.8fr_1.2fr]">
          <SectionHead eyebrow="FAQ" title="Questions about working with us" />
          <FaqList faqs={FAQS} idPrefix="process-faq" />
        </div>
      </section>
      <CtaBand title="Start a conversation" />
    </>
  );
}
